<template>
  <div class="relative overflow-hidden">
    <label
      :class="[loading ? 'invisible' : 'visible']"
      class="relative file-container cursor-pointer"
      @click="showSignUp">
      <InlineSvg
        :src="require('@/assets/fontawesome/regular/paperclip.svg')"
        :class="{
          'hover:text-link': !chatUser.deleted,
          'opacity-30': chatUser.deleted
        }"
        class="text-gray-400 h-6"/>

      <!-- accept="image/*,video/*" -->
      <input
        v-if="isAuthenticated"
        id="attachment-input"
        :disabled="chatUser.deleted"
        accept="image/*"
        type="file"
        @change="uploadAttachment">
    </label>

    <Spinner
      :class="[loading ? 'visible' : 'invisible']"
      class="absolute inset-0"/>
  </div>
</template>

<script>
import Spinner from '@/components/Functional/Spinner'
import { mapActions, mapState, mapWritableState } from 'pinia'
import { useChatStore } from '@/stores/chat.js'
import { useUserStore } from '@/stores/user.js'
import { useAuthStore } from '@/stores/auth.js'
import helpers from '@/helpers'

export default {
  name: 'ChatAttachmentUpload',
  components: {
    Spinner
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState(useAuthStore, [
      'isAuthenticated'
    ]),
    ...mapState(useChatStore, [
      'attachmentSupport'
    ]),
    ...mapWritableState(useChatStore, [
      'attachmentSizeUploadError',
      'chatUser'
    ]),
    ...mapState(useUserStore, [
      'balance',
      'rates'
    ])
  },
  async mounted () {
  },
  methods: {
    ...mapActions(useChatStore, [
      'sendPhoto',
      'sendVideo'
    ]),
    async uploadAttachment (event) {
      if (event.target.files && event.target.files[0] && !this.loading) {
        this.loading = true
        const attachment = event.target.files[0]

        const megabytes = (attachment.size / 1048576).toFixed()

        if (megabytes > 1024) {
          this.attachmentSizeUploadError = 'Maximum file size is 1GB'
          this.loading = false
          return
        }
        else {
          this.attachmentSizeUploadError = null
        }

        try {
          if (attachment.type.includes('image')) {
            await this.sendPhoto(attachment)
              .finally(() => {
                this.loading = false
              })
          }
          else {
            await this.sendVideo(attachment)
              .finally(() => {
                this.loading = false
              })
          }
        } catch (error) {
          this.attachmentSizeUploadError = error?.message ? error.message : 'Upload error'
        }
      }
    },
    showSignUp () {
      if (!this.isAuthenticated) {
        helpers.openSignInByEmailModal()
      }
    }
  }
}
</script>

<style>
  .file-container [type=file] {
    display: block;
    filter: alpha(opacity=0);
    min-height: 100%;
    min-width: 100%;
    opacity: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
  }

  .attachment-tooltip {
    text-align: center;
    border-radius: 4px;
    padding: 8px 8px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: calc(100% + 12px);
    margin: auto;
    width: max-content;
    margin-left: -8px;
    font-weight: bold;
  }

  .attachment-tooltip::after {
    content: "";
    position: absolute;
    top: 100%;              /* стрелка снизу */
    left: 15px;              /* отступ от левого края */
    border-width: 6px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
</style>
